


import { Component, Vue } from "vue-property-decorator";

import {
    Coupon,
    CustomNotification,
    GlobalConfiguration
} from "App/Models";

import { Configuration, Coupons } from "App";

import { EventBus } from "App/IOC";

/* Formulaire coupon partagé : en mode "coupon annuel" il édite la réduction (% ou montant fixe) et
   les plans/prix associés, et masque le reste (nom, code, clients, durée, expiration). */
import CouponForm from "../../Coupons/Single/Form.vue";

@Component({
    components: {
        CouponForm
    }
})
export default class YearlyCouponConfiguration extends Vue {
    private configuration: GlobalConfiguration | undefined = {} as GlobalConfiguration;

    /* Coupon annuel par défaut, édité inline (réduction + plans) via le formulaire coupon partagé.
       Null tant que le coupon annuel n'est pas chargé. */
    private couponRecord: Coupon | null = null;

    private async created(): Promise<void> {
        await this.load();
    }

    private async load(): Promise<void> {
        const [ configuration, error ] = await Configuration.Get();

        if( error !== undefined || configuration === undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.configuration = configuration;

        await this.loadCoupon();
    }

    /* Charge le coupon annuel complet (plans, prix globaux, clients) pour l'édition inline. Le
       formulaire coupon préfixe lui-même les noms de plans avec leur produit au montage. */
    private async loadCoupon(): Promise<void> {
        const coupon = this.configuration !== undefined
            ? this.configuration.YearlyCoupon
            : undefined;

        if( coupon === undefined || coupon.Id === undefined ) {
            this.couponRecord = null;
            return;
        }

        const [ record, error ] = await Coupons.Get( coupon.Id );

        if( error !== undefined || record === undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.couponRecord = record as Coupon;
    }

    /* Sauvegarde des modifications du coupon annuel (réduction %, plans, prix globaux). */
    private async saveCoupon( record: Coupon ): Promise<void> {
        if( this.couponRecord === null )
            return;

        const [ updated, error ] = await Coupons.Update( this.couponRecord, record );

        if( error !== undefined || updated === undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.couponRecord = updated as Coupon;

        EventBus.Publish( "Notification", CustomNotification.Success(
            this.$t( "GLOBAL_COUPON" ).toString(),
            this.$t( "COUPONS_updated" ).toString()
        ));
    }
}
